/*!
 * GenOptics Awaken Carousel — custom-image-slideshow.js
 */
(function () {
  'use strict';

  /**
   * Initialise a single .genoptics-awaken section.
   * @param {HTMLElement} section
   */
  function initSection(section) {
    var track  = section.querySelector('.genoptics-awaken__track');
    var slides = Array.from(section.querySelectorAll('.genoptics-awaken__slide'));
    var dots   = Array.from(section.querySelectorAll('.genoptics-awaken__dot'));

    // Nothing to do if there is no track or no slides
    if (!track || slides.length === 0) return;

    var autoplay      = section.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    var currentIndex  = 0;
    var autoplayTimer = null;
    var resumeTimer   = null;

    /* ── Navigation ───────────────────────────────────────────────────── */

    function goToSlide(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      // Set scrollLeft directly — CSS scroll-behavior: smooth on the track
      // drives the animation. This avoids scrollTo() being cancelled by snap.
      track.scrollLeft = track.offsetWidth * index;
      setActiveDot(index);
      currentIndex = index;
    }

    /* ── Dot state ────────────────────────────────────────────────────── */

    function setActiveDot(activeIndex) {
      dots.forEach(function (dot, i) {
        var isActive = i === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    /* ── Dot click listeners ──────────────────────────────────────────── */

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(parseInt(dot.dataset.slide, 10));
        // Reset autoplay timer so the interval restarts from this point
        stopAutoplay();
        scheduleResume();
      });
    });

    /* ── Sync active dot on scroll ────────────────────────────────────── */
    // Prefer IntersectionObserver (accurate); fall back to scroll event.

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = parseInt(entry.target.dataset.slideIndex, 10);
              if (!isNaN(idx) && idx !== currentIndex) {
                setActiveDot(idx);
                currentIndex = idx;
              }
            }
          });
        },
        { root: track, threshold: 0.5 }
      );
      slides.forEach(function (slide) { io.observe(slide); });
    } else {
      track.addEventListener('scroll', function () {
        var trackWidth = track.offsetWidth || 1;
        var idx = Math.round(track.scrollLeft / trackWidth);
        idx = Math.max(0, Math.min(idx, slides.length - 1));
        if (idx !== currentIndex) {
          setActiveDot(idx);
          currentIndex = idx;
        }
      }, { passive: true });
    }

    /* ── Autoplay ─────────────────────────────────────────────────────── */

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        goToSlide((currentIndex + 1) % slides.length);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function scheduleResume() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, autoplaySpeed);
    }

    if (autoplay) {
      startAutoplay();

      var carousel = section.querySelector('.genoptics-awaken__carousel');
      if (carousel) {
        // Pause while the user hovers or focuses within the carousel
        carousel.addEventListener('mouseenter', function () {
          stopAutoplay();
          clearTimeout(resumeTimer);
        });
        carousel.addEventListener('mouseleave', startAutoplay);

        carousel.addEventListener('focusin', function () {
          stopAutoplay();
          clearTimeout(resumeTimer);
        });
        carousel.addEventListener('focusout', function (e) {
          // Only resume when focus has truly left the carousel
          if (!carousel.contains(e.relatedTarget)) {
            startAutoplay();
          }
        });
      }
    }

    /* ── Initial state ────────────────────────────────────────────────── */
    setActiveDot(0);
  }

  /* ── Bootstrap ──────────────────────────────────────────────────────── */

  function boot() {
    document.querySelectorAll('.genoptics-awaken').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-initialise when the Shopify theme editor loads/reloads this section
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector
      ? e.target.querySelector('.genoptics-awaken')
      : null;
    if (el) initSection(el);
  });

})();
